const SET_BROWSE_DASHBOARD = (state, payload) => {
  state.currentOrigin.subjectSummaries = payload.subjectSummaries;
  state.currentOrigin.categorySummaries = payload.categorySummaries;

  state.user = payload.user;
  state.usageEventsDisabled = payload.usageEventsDisabled;
};

export default SET_BROWSE_DASHBOARD;
